import { useState } from "react";
import styled from "styled-components";
import MaterialInput from "../../helperComponents/MaterialInput";
import NomenclatureOfEmployee from "../../pages/loggedIn/nomenclature/NomenclatureOfEmployee";
import { serverLine } from "../../../controllers/network/serverLine";
import LoadingSection from "../../helperComponents/LoadingSection";
import goTo from "../../../controllers/goTo";

const SearchContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  padding: 0;
  justify-content: center;
  align-items: center;
`;

export default function AddAbsenceReplacement({
  userID,
  date,
  callback,
  mode = "absence",
  vacantSlot,
  onBeforeAssign,
}) {
  const [loading, setLoading] = useState(false);
  const [tmpValue, setTmpValue] = useState(null);
  const [inheritedSearchQuery, setInheritedSearchQuery] = useState(null);

  if (loading) return <LoadingSection />;

  return (
    <Container>
      <SearchContainer>
        <MaterialInput
          label={"Recherche"}
          value={tmpValue}
          onEnter={(e) => {
            setInheritedSearchQuery(e.target.value);
          }}
          onChange={(e) => {
            setTmpValue(e.target.value);
          }}
        />
      </SearchContainer>

      {inheritedSearchQuery ? (
        <NomenclatureOfEmployee
          onCardClick={addReplacement}
          forcedIsActive={"TRUE"}
          disableFilters={true}
          inheritedSearchQuery={inheritedSearchQuery}
        />
      ) : null}
    </Container>
  );

  async function addReplacement(doc) {
    try {
      if (typeof onBeforeAssign === "function") {
        const allowed = await onBeforeAssign(doc);
        if (!allowed) return;
      }

      setLoading(true);
      if (mode === "vacant") {
        await serverLine.post("/vacant-slot-assignment", {
          replacementUserID: doc._id,
          date,
          siteID: vacantSlot?.siteID,
          shift: vacantSlot?.shift,
          slotIndex: vacantSlot?.slotIndex,
        });
      } else {
        const path =
          mode === "rest" ? "/rest-replacement" : "/absence-replacement";
        await serverLine.post(path, {
          replacementUserID: doc._id,
          userID,
          date,
        });
      }
      setLoading(false);
      if (typeof callback === "function") {
        callback();
        goTo(-1)();
      }
    } catch (err) {
      console.error("Error adding replacement:", err);
    }
  }
}
